import React from "react"
import { Centralizer, Container, Button, Grid, Group } from "../components"
import { useTranslate } from "../hooks";
import { dialog } from "../utils";
import { useNavigate } from "react-router-dom";

const SupportPage = () => {

  const { t, tZod } = useTranslate();
  const navigate = useNavigate()

  return <Centralizer>
    <Container>
      <Grid>
        <Group label={t('support')}>
          <Button
            onClick={async () => {
            localStorage.setItem("hideTour", "0")
            navigate("/shipments")
            }}
          >{t("rerunTour")}</Button>
          <br/>
          <a href={t('schipt_useragreement_link')} target='_blank' rel='noreferrer' className="btn schipt-btn secondary">{t('schipt_useragreement_linktext')}</a>
          <a href={t('Faq_link')} target='_blank' rel='noreferrer' className="btn schipt-btn secondary">{t('Faq')}</a>
        </Group>               
      </Grid>
    </Container>
  </Centralizer>
}

export default SupportPage